import axios from "axios";
import {config} from "../constants";
import authHeader from "./auth-header";
import CommonService from "./common.service";

class ExcelSearchService {

    upload(data, minMatchRate, includeLocalSanctions, includePeP) {
        return axios.post(
            config.API_URL + "excel-search/upload/" + minMatchRate + "/" + includeLocalSanctions + "/" + includePeP + "/" + CommonService.getLang(),
            data,
            {headers: authHeader()}
        );
    }

    findAll() {
        return axios.get(config.API_URL + "excel-search", {headers: authHeader()});
    }

    downloadFile(fileId) {
        return axios.get(config.API_URL + "excel-search/download/" + fileId, {headers: authHeader(), responseType: "blob"});
    }

    deleteExcel(id) {
        return axios.post(config.API_URL + "excel-search/delete/" + id, {}, {headers: authHeader()});
    }

    researchExcel(id) {
        return axios.post(config.API_URL + "excel-search/research/" + id, {}, {headers: authHeader()});
    }

}

export default new ExcelSearchService();
